import React from "react";
import useHoverTooltip from "./useHoverTooltip";
import "./EllipsisText.css";

/** Text on one line, cut with an ellipsis; the full text shows in a tooltip while hovered. */
function EllipsisText({text, fallback = null, fill = false, style}) {
    const {show, hide, tooltip} = useHoverTooltip(text);
    if (!text) {
        return fallback;
    }

    return (
        <>
            <span className={fill ? "ellipsisText ellipsisTextFill" : "ellipsisText"} style={style}
                  onMouseEnter={show} onMouseLeave={hide}>
                {text}
            </span>
            {tooltip}
        </>
    );
}

// Memoised: a column resize re-renders every cell on each mouse move, and the text has not changed.
export default React.memo(EllipsisText);
